/* eslint-disable react-hooks/rules-of-hooks */
import { h } from "preact";
import { useContext, useEffect, useState } from "preact/hooks";

import LoadingContentPreloader from "./LoadingContentPreloader";

import {
  useUser,
  useAuth,
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreCollectionDataWithLimit,
} from "../lib/preactfire";
import { Context, setUserInfoAction, changeId } from "../lib/globalState";
import {
  addNoScroll,
  removeNoScroll,
  removeOverlay,
  timeAgo,
} from "../lib/helper";

export default function UserInfoModal() {
  const { state, dispatch } = useContext(Context);
  const [limit, setLimit] = useState(5);

  useEffect(() => {
    addNoScroll();

    return () => {
      removeNoScroll();
    };
  }, []);

  if (state.userInfoVisible) {
    const auth = useAuth();
    const user = useUser();
    const { user_id, name, profile_img } = state.userInfo;

    const repliesRef = useFirestore()
      .collection("comment")
      .where("type", "==", "comment")
      .where("user_id", "==", user_id);
    const repliesCount = useFirestoreCollectionData(repliesRef).length;
    const replies = useFirestoreCollectionDataWithLimit(repliesRef, limit);

    return (
      <div className="modal user-info-modal show">
        <div className="comment-profile-modal">
          <div className="modal-header">
            <span style="font-size: 20px;">Profile</span>
            <span
              className="close"
              onClick={() => {
                removeOverlay();
                dispatch(setUserInfoAction(null, false));
                dispatch(changeId(0, false));
              }}
            >
              <svg
                height="1em"
                fill="currentColor"
                viewBox="0 0 14 14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M7 5.586L1.414 0 0 1.414 5.585 7 0 12.586 1.414 14 7 8.414 12.586 14l1.413-1.414L8.414 7l5.585-5.586L12.586 0z" />
              </svg>
            </span>
          </div>
          <div id="modal_profile" className="modal-profile-content">
            <div id="userinfoinsidemodal">
              <div className="comment-popup-profile">
                <img src={profile_img} className="comment-popup-img" />
                <div className="comment-popup-name">{name}</div>
                <div className="comment-popup-count">
                  {repliesCount} Comment{repliesCount > 1 && "s"}
                </div>
                {user?.uid === user_id && (
                  <button
                    className="d-block"
                    onClick={() => {
                      removeOverlay();
                      dispatch(setUserInfoAction(null, false));
                      auth.signOut();
                    }}
                  >
                    Logout
                  </button>
                )}
              </div>
            </div>
          </div>
          {replies === undefined && repliesCount > 0 ? (
            <LoadingContentPreloader />
          ) : (
            <div className="modal-comment-content">
              {replies?.map((reply) => (
                <div key={reply.id} className="comment-item-modal">
                  <div className="comment-meta">
                    <span className="comment-ts">
                      {timeAgo(reply.timestamp)}
                    </span>
                  </div>

                  <div
                    className="comment-text"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: reply.text }}
                  />

                  <div className="comment-popup-story">
                    <a href={reply.page} target="_blank" rel="noreferrer">
                      <div className="popup-story-img">
                        <img src={reply.image} width="52" height="52" />
                      </div>
                      <div className="popup-story-title">
                        <div className="popup-title-text">{reply.title}</div>
                        <div className="popup-story-site">{reply.page}</div>
                      </div>
                    </a>
                  </div>
                </div>
              ))}

              {repliesCount !== replies?.length && (
                <div className="loading-content">
                  <button
                    type="button"
                    name="button"
                    className="load-feed-modal"
                    style="display: show"
                    onClick={() => setLimit(limit + 5)}
                  >
                    Load more
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }

  return null;
}
